import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgVerification = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M15.5 29.097c0-5.862 0-8.793.692-9.78.692-.985 3.448-1.929 8.96-3.815l1.05-.36c2.874-.983 4.31-1.475 5.798-1.475s2.924.492 5.798 1.475l1.05.36c5.512 1.886 8.268 2.83 8.96 3.816s.692 3.917.692 9.78v2.886c0 10.337-7.772 15.353-12.647 17.483-1.323.578-1.984.866-3.853.866s-2.53-.288-3.853-.866C23.271 47.337 15.5 42.32 15.5 31.984z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M47.125 29.098c0-2.949 0-5.102-.084-6.644-.042-.77-.103-1.341-.183-1.756a3 3 0 0 0-.116-.455 1 1 0 0 0-.06-.134 1 1 0 0 0-.1-.094 3 3 0 0 0-.38-.256c-.361-.209-.875-.45-1.584-.737-1.42-.577-3.443-1.271-6.216-2.22l-1.05-.358c-2.96-1.013-4.146-1.402-5.352-1.402s-2.392.389-5.351 1.402l-1.051.358c-2.773.949-4.797 1.643-6.216 2.22-.709.288-1.223.528-1.583.737-.178.104-.3.19-.381.256a1 1 0 0 0-.1.093 1 1 0 0 0-.06.135c-.036.103-.077.25-.116.455-.08.415-.14.986-.183 1.756-.084 1.542-.084 3.695-.084 6.644v2.886c0 9.487 7.096 14.157 11.824 16.222.68.298 1.073.467 1.51.579.419.107.93.173 1.791.173.862 0 1.372-.066 1.79-.173.438-.112.83-.281 1.511-.578 4.728-2.066 11.824-6.736 11.824-16.223zm2.75 2.886c0 11.185-8.449 16.549-13.472 18.743-.642.28-1.24.545-1.93.722-.71.182-1.466.26-2.473.26s-1.762-.078-2.472-.26c-.69-.177-1.29-.442-1.93-.722-5.024-2.194-13.473-7.558-13.473-18.743v-2.886c0-2.914-.001-5.16.088-6.794.044-.82.114-1.533.229-2.127.11-.572.286-1.166.625-1.65.343-.488.848-.853 1.352-1.145.523-.304 1.172-.601 1.928-.908 1.509-.613 3.622-1.336 6.36-2.274l1.05-.36c2.787-.953 4.474-1.548 6.243-1.548s3.456.595 6.243 1.548l1.05.36c2.738.938 4.851 1.661 6.36 2.274.756.307 1.406.604 1.928.908.504.292 1.01.657 1.352 1.146.34.483.515 1.077.625 1.649.115.594.185 1.308.23 2.127.088 1.635.087 3.88.087 6.794z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M26.5 32a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0m7.333 0a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M33.833 32a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0m7.334 0a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0"
      />
    </svg>
  );
};
export default SvgVerification;
